module.exports = __webpack_public_path__ + "img/logo-light.da235529.png";